export async function copyButton() {
  await navigator.clipboard.writeText(this.getAttribute("data-copy-text"));
}

export function assignCopyButtons() {
  const buttons = document.querySelectorAll("[data-copy-text]");
  [...buttons].forEach(el => el.addEventListener("click", copyButton));
}
